export default "__VITE_ASSET__BZXvlGtH__"